import { useAuth } from 'hooks/useAuth';
import { useMemo } from 'react';
import { meetsColumnRequirements } from 'utils/helpers/license';

/**
 * Filters columns to those the user is licensed to use. Licence-blocked
 * columns are hidden unconditionally regardless of the entry point — they
 * still round-trip through the save payload so a later licence re-upgrade
 * restores the user's prior selection.
 *
 * @param {string[]} columnOrder
 * @param {Record<string, import('reducers/exportTemplate/state').EditingColumn>} columnsMap
 */
export const useLicenseFilteredColumns = (columnOrder, columnsMap) => {
  const { hasLicense } = useAuth();

  const columns = useMemo(() => {
    return columnOrder
      .map(colId => {
        const col = columnsMap[colId];
        if (!col) return null;
        if (!meetsColumnRequirements(col.requirements, hasLicense)) return null;
        return col;
      })
      .filter(Boolean);
  }, [columnOrder, columnsMap, hasLicense]);

  return { columns };
};
